// console.log('resources/assets/js/config.js');
/*
    Defines the API route we are using.
*/
// var apiUrl = '/api/v1';
var apiUrl = '/api';

// switch( process.env.NODE_ENV ){
//   case 'development':
//     apiUrl = 'https://roast.dev/api/v1';
//   break;
//   case 'production':
//     apiUrl = 'https://roastandbrew.coffee/api/v1';
//   break;
// }

export const API_CONFIG = {
	API_URL: apiUrl
};
